import SideNav from "./sidenav";
import React, { useState, useEffect, Component } from "react";
import "./careers.css";
import Footer from "./footer";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Pagination, Table } from 'react-bootstrap';
import { GoDotFill } from "react-icons/go";
import CareersBg from "../images/Careers.jpg";
import Mobilenav from "./mobiledropdwn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import AOS from 'aos';


const client = new ApolloClient({
  link: new HttpLink({ uri: "https://pensure-cms.inspireleadership.biz/graphql"}),
  cache: new InMemoryCache(),
});


const Careers = () => {

   window.scrollTo(0, 0)


  const [active, setActive] = useState("ALL");
  const [jobsIndex, setJobsIndex] = useState("")
  const [jobsIndexHybrid, setJobsIndexHybrid] = useState(0)
  const [jobsIndexOnsite, setJobsIndexOnsite] = useState(0)
  const [jobsIndexRemote, setJobsIndexRemote] = useState(0)
  const [heroBanner, setHeroBanner] = useState([])
  const [heroMobile, setHeroMobile] = useState([])
  const [listSections, setListSections] = useState([])
  const [productInfo, setProductInfo] = useState([])
  const [data, setData] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [allCareerContent, setAllCareerContent] = useState([]);
  const menuItems = ["ALL", "REMOTE", "ONSITE", "HYBRID"];


  const itemsPerPage = 6;

  // Calculate indexes for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Generate pagination items
  let items = [];
  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item 
        key={number} 
        active={number === currentPage}
        onClick={() => setCurrentPage(number)}
      >
        {number}
      </Pagination.Item>
    );
  }



  const careersData = [
    {
      title: "Open Positions",
      jobs: [
        {
          position: "Claims Officer",
          Location: "Lagos, Nigeria",
          type: "Full-Time",
          WorkingMode: "Onsite",
          Experience: "Mid-Level",
        },
      ],
    },
  ];

    useEffect(() => {
      
         AOS.init({
          offset: 0,
          duration: 1000,
          once: true
        });
      
          
      }, [])


         useEffect( () => {
        
        client
          .query({
            query: gql`
          query NewQuery {
pages {
    edges {
      node {
        id
        job {
          hero {
            buttonLink
            buttonName
            caption
            description
            heading
            image {
              mediaItemUrl
            }
          }
          heromobile {
            buttonLink
            buttonName
            caption
            heading
            image {
              mediaItemUrl
            }
          }
          listSection {
            explanation
            heading
            image {
              mediaItemUrl
            }
            list {
              item
              icon {
                mediaItemUrl
              }
            }
          }
         
          
          productInfo {
            explanation
            heading
          }
        }
      }
    }
  }
        }
            `,
          })
          .then((result) => {
        
             console.log(result)
        
        setHeroBanner(result.data.pages.edges[3].node.job.hero)
        setHeroMobile(result.data.pages.edges[3].node.job.heromobile)
        setListSections(result.data.pages.edges[3].node.job.listSection)
        setProductInfo(result.data.pages.edges[3].node.job.productInfo)

        
        
          });



      
        
 client
   .query({
    query: gql`
      query NewQuery {
          career {
         edges {
         node {
         id
        jobsPage {
          contract
          entryLevel
          fullTime
          introduction
          hybrid
          fieldGroupName
          midLevel
          onsite
          partTime
          location
          qualities {
            list
          }
          remote
          requirements {
            list
          }
          responsibilities {
            list
          }
          role
          seniorLevel
          summary
        }
      }
    }
  }
        }
            `,
          })
          .then((result) => {
        
             console.log(result)
              
              let careerContentArray = []
              let careerArray
              let jobType
              let jobLevel
              let jobMode
              let jobTitle
              let jobId
              let jobLocation

              for(let x=0; x < result.data.career.edges.length; x++ ){ 

          

                console.log(result.data.career.edges[x].node.jobsPage.contract)

                //set the job type 
              if(result.data.career.edges[x].node.jobsPage.contract){
                       jobType = "Contract"
               }
              if(result.data.career.edges[x].node.jobsPage.fullTime){
                   jobType = "Full Time"
              }
              if(result.data.career.edges[x].node.jobsPage.partTime){
                       jobType = "Part Time"
               }
                //set the job level 
              if(result.data.career.edges[x].node.jobsPage.entryLevel){
                       jobLevel = "Entry Level"
               }
              if(result.data.career.edges[x].node.jobsPage.midLevel){
                   jobLevel = "Mid Level"
              }
              if(result.data.career.edges[x].node.jobsPage.seniorLevel){
                       jobLevel = "Senior Level"
               }

                    //set the job mode 
              if(result.data.career.edges[x].node.jobsPage.remote){
                       jobMode = "Remote"
                          if( x < result.data.career.edges.length - 1){
                       setJobsIndexRemote(prev => prev + 1);
                          }
               }
              if(result.data.career.edges[x].node.jobsPage.hybrid){
                   jobMode = "Hybrid"
                      if( x < result.data.career.edges.length - 1){
                    setJobsIndexHybrid(prev => prev + 1);
                      }
              }
              if(result.data.career.edges[x].node.jobsPage.onSite){
                       jobMode = "Onsite"
                          if( x < result.data.career.edges.length - 1){
                        setJobsIndexOnsite(prev => prev + 1);
                          }
               }
                  
               jobTitle  =  result.data.career.edges[x].node.jobsPage.role 
             
               jobId = result.data.career.edges[x].node.id
               jobLocation = result.data.career.edges[x].node.jobsPage.location

                 careerArray = [{title:jobTitle, mode: jobMode, level: jobLevel, type: jobType, id: jobId, location: jobLocation }]

                careerContentArray.push(careerArray)
                
                if( x < result.data.career.edges.length - 1){
                setData(prevCareerArray => [...prevCareerArray, careerArray])
                }
                setJobsIndex(result.data.career.edges.length)
                 console.log(allCareerContent)
                  
              }


              
       
 


          });
        
        }, [])  
  

      function buttonCall(){ 
const target = document.getElementById('careerContent');

target.scrollIntoView({ behavior: 'smooth' });

  }


        let listSectionsDisplay
        let productInfoDisplay
        let heroBannerDisplay
        let heroMobileDisplay
        
        
        
          if(heroBanner.length > 0 ){
          heroBannerDisplay = heroBanner.map((banner, i) => 
        
                <div className="rsa-cover">
                  <img className="rsa-bg" src={banner.image.mediaItemUrl} />
                  <div className="rsa-content">
                    <div className="rsa-txt">
                      <h1 className="rsa-h1"  data-aos="zoom-in" data-aos-delay="200"> {banner.heading} </h1>
                      <p className="grey-p"  data-aos="fade-up" data-aos-delay="200">
                        {banner.caption}
                      </p>
                      <a className="btn-trns" onClick={buttonCall}  data-aos="fade-up" data-aos-delay="200">
                        {" "}
                        {banner.buttonName}{" "}
                        <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
                      </a>
                    </div>
                  </div>
                </div>
          )
        }
        
        
          if(heroMobile.length > 0 ){
          heroMobileDisplay = heroMobile.map((banner, i) => 
        
                <div className="rsa-cover">
                  <img className="rsa-bg" src={banner.image.mediaItemUrl} />
                  <div className="rsa-content">
                    <div className="rsa-txt">
                      <h1 className="rsa-h1 " data-aos="zoom-in" data-aos-delay="200"> {banner.heading} </h1>
                      <p className="grey-p" data-aos="fade-up" data-aos-delay="200">
                        {banner.caption}
                      </p>
                      <a className="btn-trns" onClick={buttonCall} data-aos="fade-up" data-aos-delay="200">
                        {" "}
                        {banner.buttonName}{" "}
                        <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
                      </a>
                    </div>
                  </div>
                </div>
          )
        }
        
        
        
          if(productInfo.length > 0 ){
          productInfoDisplay = productInfo.map((info, i) => 
         <div className="card avc-crd text-start">
              <figure className="compact-settings-avc-works">
                <p className="avc-works-numeral" data-aos="fade-up" data-aos-delay="200">    {i + 1} </p>
                <figcaption>
                  <h5 className="card-subtitle pb-2 statement-hdr" data-aos="fade-up" data-aos-delay="200">
                   {info.heading}
                  </h5>
                  <p
                    className="card-text grey-p-avc"
                    style={{ fontSize: "16px" }}
                  
                  data-aos="fade-up" data-aos-delay="200">
                    {info.explanation}
                  </p>
                </figcaption>
              </figure>
            </div>
           
          )
        }
        
        
if(listSections.length > 0){ 
      
      
          listSectionsDisplay = listSections.map((section, i) => 
             
      
                    i % 2 ? 


        <div id="mobile-view"  className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5">
                  

        <div  className="pension-div1 pb-3" >
          <h3 className="rma-h3 pb-5" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>

              <p className="grey-p-pms  pb-2 " style={{ color: "#3B475A", width: "470px" }} data-aos="fade-up" data-aos-delay="200">
           {section.explanation}
          </p>
       

          <ul
            className="pt-2 custom-squar no-padding-left"
            style={{ listStyleType: "square"}}
          >

                {section.list.map( (items,i) => 
                
                    <li className="pb-3 pt-3 d-flex align-items-center btm-bdr" data-aos="fade-up" data-aos-delay="200">
                  <span className="bckground">
                    <img className="" src= {items.icon.mediaItemUrl} />
                  </span>

                  <h6 className="ps-3"> {items.item} </h6>
                </li>
           

            
            )
            
            }
        
          </ul>
        </div>

         <div className="d-flex justify-content-end">
                    <img className="img-fluid" src={section.image.mediaItemUrl} />
                  </div>
                </div>
        
      
          
          :
        <div id="mobile-view"  className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5">
                  

        

        <div  className="pension-div1 pb-5">
          <h3 className="rma-h3 pb-3" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>

              <p className="grey-p-pms  pb-2" style={{ color: "#3B475A", width: "470px" }} data-aos="fade-up" data-aos-delay="200">
           {section.explanation}
          </p>
      

          <ul
            className="pt-2 custom-square no-padding-left"
            style={{ listStyleType: "square"}}
          >

                {section.list.map( (items,i) => 
                
                    <li className="pb-3 pt-3 d-flex align-items-center btm-bdr" data-aos="fade-up" data-aos-delay="200">
                  <span className="bckground">
                    <img className="" src= {items.icon.mediaItemUrl} />
                  </span>

                  <h6 className="ps-3"> {items.item} </h6>
                </li>
           


          
            )
            
            }
        
          </ul>
        </div>

          <div className="d-flex justify-content-end">
                    <img className="img-fluid" src={section.image.mediaItemUrl} />
                  </div>
            

                </div>

            
          )
      
        }



  return (
    <>
      <div className="leadership-container d-block d-sm-none">
        {heroMobileDisplay}
       
      </div>
          <div className="leadership-container d-none d-sm-block">
       {heroBannerDisplay}
      </div>
      <div
        id="payment-types-section"
        class="containner d-flex align-items-start justify-content-between  mt-4"
        style={{ backgroundColor: "none" }}
      >
        <div className="side-rsp">
          <SideNav
            className={"career-side-nav"}
            items={menuItems}
            activeItem={active}
            onSelect={setActive}
            funds={false}
          />
          <Mobilenav
            className={""}
            items={menuItems}
            activeItem={active}
            onSelect={setActive}
          />

          <div className="rght-side flex-1 p-6" id="careerContent">
            {active === "ALL" && (
              <div className="payment-type-content">
                <h2 id="cr-h2" className="payment-h2">
                  {" "}
                  Open Positions <sub className="subText"> ({jobsIndex}) </sub>
                </h2> 

                {currentItems.map((job, index) => (
                  <div key={index} id="job-card" className=" " data-aos="fade-up" data-aos-delay="200">
                    <div >
                      {" "}
                      <h5 className="job-title">{job[0].title}</h5>
                      <div className="job-info">
                        <span className="job-location">{job[0].location}</span>
                        <GoDotFill
                          className="ms-1 me-1"
                          style={{ fontSize: "8px" }}
                        />
                        <span className="job-type">{job[0].type}</span>
                        <GoDotFill
                          className="ms-1 me-1"
                          style={{ fontSize: "8px" }}
                        />
                        <span className="job-working-mode">{job[0].mode}</span>
                        <GoDotFill
                          className="ms-1 me-1"
                          style={{ fontSize: "8px" }}
                        />
                        <span className="job-experience">{job[0].level}</span>{" "}
                      </div>
                    </div>
                    <a
                      id="apply-btn"
                      class="open-acc-btn-spc  grey-p"
                      href={`/career-single/${job[0].id}`}
                    >
                      Apply Now{" "}
                      <FontAwesomeIcon
                        className="chv-dwn--footer"
                        icon={faArrowRight}
                      />
                    </a>


                  </div>

                  
                ))}

             <div className="paginationDiv mx-auto"> 
                       <Pagination>
         {items}
        <Pagination.Next className="ps-2" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
   
      </Pagination>
      </div>
              </div>
            )}
            {active === "REMOTE" && (
                 <div className="payment-type-content">
                <h2 id="cr-h2" className="payment-h2">
                  {" "}
                  Remote Positions <sub className="subText"> ({jobsIndexRemote}) </sub>
                </h2> 

                   {currentItems.map((job, index) => (
                                  
                          job[0].mode === "Remote" ?
                  <div key={index} id="job-card" className=" " data-aos="fade-up" data-aos-delay="200">
                    <div>
                      {" "}
                      <h5 className="job-title">{job[0].title}</h5>
                      <div className="job-info">
                        <span className="job-location">{job[0].location}</span>
                        <GoDotFill
                          className="ms-1 me-1"
                          style={{ fontSize: "8px" }}
                        />
                        <span className="job-type">{job[0].type}</span>
                        <GoDotFill
                          className="ms-1 me-1"
                          style={{ fontSize: "8px" }}
                        />
                        <span className="job-working-mode">{job[0].mode}</span>
                        <GoDotFill
                          className="ms-1 me-1"
                          style={{ fontSize: "8px" }}
                        />
                        <span className="job-experience">{job[0].level}</span>{" "}
                      </div>
                    </div>
                    <a
                      id="apply-btn"
                      class="open-acc-btn-spc  grey-p"
                      href={`/career-single/${job[0].id}`}
                    >
                      Apply Now{" "}
                      <FontAwesomeIcon
                        className="chv-dwn--footer"
                        icon={faArrowRight}
                      />
                    </a>


                  </div>

                  :

                  " "

                  
                ))}
              </div>

            )}
            {active === "ONSITE" && (
                             <div className="payment-type-content">
                <h2 id="cr-h2" className="payment-h2">
                  {" "}
                  Onsite Positions <sub className="subText"> ({jobsIndexOnsite}) </sub>
                </h2> 

                                {currentItems.map((job, index) => (
                                  
                          job[0].mode === "Onsite" ?
                  <div key={index} id="job-card" className=" " data-aos="fade-up" data-aos-delay="200">
                    <div>
                      {" "}
                      <h5 className="job-title">{job[0].title}</h5>
                      <div className="job-info">
                        <span className="job-location">{job[0].location}</span>
                        <GoDotFill
                          className="ms-1 me-1"
                          style={{ fontSize: "8px" }}
                        />
                        <span className="job-type">{job[0].type}</span>
                        <GoDotFill
                          className="ms-1 me-1"
                          style={{ fontSize: "8px" }}
                        />
                        <span className="job-working-mode">{job[0].mode}</span>
                        <GoDotFill
                          className="ms-1 me-1"
                          style={{ fontSize: "8px" }}
                        />
                        <span className="job-experience">{job[0].level}</span>{" "}
                      </div>
                    </div>
                    <a
                      id="apply-btn"
                      class="open-acc-btn-spc  grey-p"
                      href={`/career-single/${job[0].id}`}
                    >
                      Apply Now{" "}
                      <FontAwesomeIcon
                        className="chv-dwn--footer"
                        icon={faArrowRight}
                      />
                    </a>


                  </div>

                  :

                  " "

                  
                ))}
              </div>
            )}
            {active === "HYBRID" && (
                         <div className="payment-type-content">
                <h2 id="cr-h2" className="payment-h2">
                  {" "}
                  Hybrid Positions <sub className="subText"> ({jobsIndexHybrid}) </sub>
                </h2> 

                                {currentItems.map((job, index) => (
                                  
                          job[0].mode === "Hybrid" ?
                  <div key={index} id="job-card" className=" " data-aos="fade-up" data-aos-delay="200">
                    <div>
                      {" "}
                      <h5 className="job-title">{job[0].title}</h5>
                      <div className="job-info">
                        <span className="job-location">{job[0].location}</span>
                        <GoDotFill
                          className="ms-1 me-1"
                          style={{ fontSize: "8px" }}
                        />
                        <span className="job-type">{job[0].type}</span>
                        <GoDotFill
                          className="ms-1 me-1"
                          style={{ fontSize: "8px" }}
                        />
                        <span className="job-working-mode">{job[0].mode}</span>
                        <GoDotFill
                          className="ms-1 me-1"
                          style={{ fontSize: "8px" }}
                        />
                        <span className="job-experience">{job[0].level}</span>{" "}
                      </div>
                    </div>
                    <a
                      id="apply-btn"
                      class="open-acc-btn-spc  grey-p"
                      href={`/career-single/${job[0].id}`}
                    
                    >
                      Apply Now{" "}
                      <FontAwesomeIcon
                        className="chv-dwn--footer"
                        icon={faArrowRight}
                      />
                    </a>


                  </div>

                  :

                  " "

                  
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="black-cont-careers ">
        <div
          id="mobile-view"
          className="containeer row d-flex justify-content-between text-center "
        >
          <div className="text-center pb-5">
            <p className="orange-p-avc pb-2" data-aos="fade-up" data-aos-delay="200"> APPLICATION PROCESS </p>
            <h2 className="career-h2" style={{ color: "#FFFFFF" }} data-aos="fade-up" data-aos-delay="200" >
              How to Get Started?
            </h2>
          </div>
          {productInfoDisplay}
        </div>
      </div>

   <div className="containeer"> 

    {listSectionsDisplay}
   </div>

   <Footer/>
           <div className='height-careers'> 

              </div>
    </>
  );
};

export default Careers;
